import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { sortBy } from 'lodash'

import { EmployeeSelectionToolIssues } from 'components/Schedule'
import { UserSpecificRestrictions, UserHiringData } from 'Manager/Users/components'
import { Table } from 'components/UI'
import { destroy, init } from 'store/actions/tables'
import { getTagNames, getAttributeNames } from 'services/Utilities'
import { t } from 'translations'

const EmployeeSelectionToolUserTable = () => {
  const { enableOccupations, enableRegionalTags } = useSelector(state => state.settings)
  const { events: templateEvents, days } = useSelector(state => state.scheduleTemplates)

  useEffect(() => {
    const usersPerDay = sortBy(templateEvents, 'multiDayIndex').reduce((acc, event) => {
      if (!event.employeeId) return acc
      if (!acc[event.employeeId]) acc[event.employeeId] = new Set()
      acc[event.employeeId].add(event.multiDayIndex + 1)
      return acc
    }, {})

    const header = [
      {
        key: 'fullName',
        label: 'NAME',
        type: 'custom',
        render: (
          fullName,
          { hiringData, attributes, regionalTags, specificRestrictions, sortData: { totalProjectExperience, totalRelatedProjectExperience } = {} }
        ) => {
          return (
            <>
              <div>
                <span className="font-weight-bold">{fullName}</span>
                {hiringData?.length ? (
                  <span className="font-italic ml-1">
                    (<UserHiringData hiringData={hiringData} canBeNull />)
                  </span>
                ) : null}
              </div>
              {enableRegionalTags ? <div>{getTagNames(regionalTags)}</div> : null}
              <div>{getAttributeNames(attributes, { withRank: true })}</div>
              <UserSpecificRestrictions specificRestrictions={specificRestrictions} canBeNull />
              <div className="font-weight-bold">
                {totalProjectExperience
                  ? t('manager.scheduleTemplates.employeeSelectionTool.PROJECT_EXPERIENCE', {
                      totalProjectExperience: Math.round(totalProjectExperience / 600) * 10
                    })
                  : null}
                {totalRelatedProjectExperience
                  ? t('manager.scheduleTemplates.employeeSelectionTool.RELATED_PROJECT_EXPERIENCE', {
                      totalRelatedProjectExperience: Math.round(totalRelatedProjectExperience / 600) * 10
                    })
                  : null}
              </div>
            </>
          )
        }
      },
      {
        key: 'issues',
        label: 'manager.scheduleTemplates.employeeSelectionTool.ISSUES',
        type: 'custom',
        render: (empty, user) => <EmployeeSelectionToolIssues user={user} alreadyInTemplate={Array.from(usersPerDay[user._id] || [])} isMulti={days > 1} />
      }
    ]

    init('st-employee-selection-tool', header, null, { content: [], count: 0, isSelectable: true, limit: 10 })
    return () => destroy('st-employee-selection-tool')
  }, [enableOccupations, enableRegionalTags, templateEvents, days])

  return <Table name="st-employee-selection-tool" />
}

export default EmployeeSelectionToolUserTable
